import Vue from 'vue'
import Vuex from 'vuex'

import admin from './modules/admin'
import colors from './modules/colors'
import copy from './modules/copy'
import header from './modules/header'
import logo from './modules/logo'
import main from './modules/main'
import mainmtr from './modules/mainmtr'
import usuarios from './modules/usuarios'
import info from './modules/info'
import suscripciones from './modules/suscripciones'
import productos from './modules/productos'
import personalizacion from './modules/personalizacion'
import storeOnline from './modules/storeOnline'
import factura from './modules/factura'
import categories from './modules/categories'
import marcas from './modules/marcas'
import atributos from './modules/atributos'
import gallery from './modules/gallery'
import related from './modules/related'
import payment from './modules/payment'
import proyectos from './modules/proyectos'
import specialist from './modules/specialist'
import availability from './modules/availability'
import statistics from './modules/statistics'
import calendar from './modules/calendar'
import notas from './modules/notas'
import bloqueos from './modules/bloqueos'
import agenda from './modules/agenda'
import slides from './modules/slides'
import sociales from './modules/sociales'
import secciones from './modules/secciones'
import categoryType from './modules/categoryType'
import event from './modules/event'
import galery from './modules/galery'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin,
    colors,
    copy,
    header,
    logo,
    main,
    mainmtr,
    usuarios,
    info,
    suscripciones,
    productos,
    personalizacion,
    storeOnline,
    factura,
    categories,
    marcas,
    atributos,
    gallery,
    related,
    payment,
    proyectos,
    specialist,
    availability,
    statistics,
    calendar,
    notas,
    bloqueos,
    agenda,
    slides,
    sociales,
    secciones,
    categoryType,
    event,
    galery
  }
})
